<template>
  <div class="div-table">
    <div class="columns is-gapless">
      <div class="column is-12 card-header has-text-centered accordion-title"
           :class="{'active': isActive}"
           @click="isActive = !isActive">
        <div class="header-container" style="width:100%">
            <strong class="is-size-7-touch">
              <v-rating
                  v-model="showStar"
                  background-color="yellow darken-1"
                  color="yellow darken-1"
                  length="1"
                  size="24"
                  disabled
              ></v-rating>
              AHL Stars (Total: {{totalStars}})</strong>
        </div>
      </div>
    </div>
    <v-data-table v-if="isActive" :items="stars" :headers="[{text:'Month / Year', value: 'monthyear'}, {text:'Stars Earned', value:'stars'}]"
      hide-default-footer
                  :custom-sort="customSort">
      <template v-slot:item.monthyear="{ item }">
        <span>{{ item.monthyear | dateFilter }}</span>
      </template>
    </v-data-table>
    <!--
    <div class="columns is-gapless is-flex">
      <div class="column is-4 has-text-centered">
        <strong class="is-size-7">Month/Year</strong>
      </div>
      <div class="column is-4 has-text-centered">
        <strong class="is-size-7">Total</strong>
      </div>
    </div>
    <div
        v-for="star in stars"
        class="columns is-gapless is-flex"
    >
      <div class="column is-6 has-text-centered">
          {{ star.monthyear }}
      </div>

      <div class="column is-6 has-text-centered">
        <span class="is-size-7">{{ star.stars }}</span>
      </div>
    </div>-->
  </div>
</template>
<style scoped>
.accordion::after, .card-user-name::after, .accordion-title::after, .member-links, .panel, .card-user {
  font-size: 1rem;
  position: relative;
  top: 20px;
}
/deep/.theme--light.v-data-table thead tr th {
  color: #000;
  font-weight:bold;
}
</style>
<script>
export default {
  props: ['stars'],
  data () {
    return {
      isActive:false,
      showStar: 1
    }
  },
  filters: {
    dateFilter(dte) {
      if (dte && dte instanceof Date) {
        return (dte.getMonth() + 1) + "/" + (dte.getFullYear())
      } else {
        return dte;
      }
    }
  },
  methods: {
    customSort: function(items, index, isDesc) {
      items.sort((a, b) => {
        if (index[0] === 'monthyear') {
          if (!isDesc[0]) {
            return new Date(b[index]) - new Date(a[index]);
          } else {
            return new Date(a[index]) - new Date(b[index]);
          }
        }
        else {
          if(typeof a[index] !== 'undefined'){
            if (!isDesc[0]) {
              return a[index].toLowerCase().localeCompare(b[index].toLowerCase());
            }
            else {
              return b[index].toLowerCase().localeCompare(a[index].toLowerCase());
            }
          }
        }
      });
      return items;
    }
  },
  computed:{
    totalStars() {
      let tStars = 0;
      this.stars.forEach((star) => {
        tStars += parseInt(star.stars);
      })
      return tStars;
    }
  }
}
</script>